import { types } from "mobx-state-tree";

export const UserProfile = types.model("UserProfile", {
  id: types.number,
  email: types.string,
  org_id: types.maybe(types.string),
  first_name: types.maybe(types.string),
  last_name: types.maybe(types.string),
  phone_number: types.maybe(types.string),
  job_title: types.maybe(types.string),
  company: types.maybe(types.string),
  avatar_url: types.maybe(types.string),
  color: types.maybe(types.string),
  allow_permanent_delete: types.maybe(types.boolean),
  tos_accepted_at: types.maybe(types.string),
  pm_digest_opt_out: types.maybe(types.boolean),
  message_board_opt_out: types.maybe(types.boolean),
});

export type IUserProfile = typeof UserProfile.Type;
